import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "md:flex md:items-center justify-center md:justify-between bg-white border-b border-gray-200 flex py-4 pl-8" }
const _hoisted_2 = { class: "max-w-lg w-full md:w-56 lg:max-w-xs" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", {
  for: "search",
  class: "sr-only"
}, "Search", -1)
const _hoisted_4 = { class: "relative text-gray-400 focus-within:text-gray-600" }
const _hoisted_5 = { class: "pointer-events-none absolute inset-y-0 pl-3 left-0 flex items-center" }
const _hoisted_6 = { class: "flex flex-col md:flex-row mx-auto md:mr-auto md:mx-0" }
const _hoisted_7 = { class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 md:pr-8 mx-auto" }
const _hoisted_8 = { class: "text-sm px-1" }
const _hoisted_9 = {
  key: 0,
  class: "mt-4 flex-shrink-0 flex md:mt-0 md:ml-4 pr-8"
}
const _hoisted_10 = { class: "py-6" }
const _hoisted_11 = { class: "sm:mx-6 md:mx-8 bg-white shadow overflow-x-auto sm:rounded-md" }
const _hoisted_12 = { class: "shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg" }

import "dayjs/locale/th";
import dayjs from "dayjs";
import stringify from "qs-stringify";
import localizedFormat from "dayjs/plugin/localizedFormat";
import { AxiosInstance } from "axios";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { inject, onMounted, ref, watch } from "vue";
import Navbar from "@/components/tools/Navbar.vue";
import DataTable from "@/components/tools/DataTable.vue";
import Pagination from "@/components/tools/Pagination.vue";
import UserBlacklistCreateDialog from "@/components/dialogs/UserBlacklistCreateDialog.vue";
import UserBlacklistConfirmDialog from "@/components/dialogs/UserBlacklistConfirmDialog.vue";
import { translate } from "@/utils/tools";
import {Switch} from "@headlessui/vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBlacklisted',
  setup(__props) {

dayjs.extend(localizedFormat);
const SearchIcon = require("@heroicons/vue/solid/SearchIcon");
const axios = inject("$axios") as AxiosInstance;
const createBlacklistUser = ref<boolean>(false);

const selectedRow = ref()
const confirmBlacklistUser = ref<boolean>(false);

const store = useStore();
const route = useRoute();
const dataRows = ref([]);
const isLoaded = ref(false);
const advanceFilterModal = ref(false);
const advanceFilterForm = ref<{createdByCMS: boolean}>({
  createdByCMS: false
})
const columns = [
  {
    label: translate("messages.blacklist.type"),
    field: "type",
    align: "left",
  },
  {
    label: translate("messages.blacklist.value"),
    field: "value",
    align: "left",
  },
  {
    label: translate("messages.blacklist.reason"),
    field: "reason",
    align: "left",
  },
  {
    label: translate("messages.blacklist.createdBy"),
    field: "createdBy",
    align: "left",
  },
  {
    label: translate("messages.blacklist.createdAt"),
    field: "createdAt",
    align: "left",
    format: (data: any) => dayjs(data.createdAt).locale("th").format("LLL"),
  },
  {
    label: "",
    field: "",
    isFunction: true,
    permission: "BLACKLIST.UNLOCK",
    format: () => translate("messages.blacklist.unlock"),
    class: (data: any) => !data.reason.includes("Exceeded") ? "hidden" : "bg-yellow-300 text-white cursor-pointer hover:bg-yellow-400",
    function: (data: any) => {
      actionBlacklistUser(data, 'unlock');
      fetchPageData();
    },
  },
  {
    label: "",
    field: "",
    isFunction: true,
    permission: "BLACKLIST.RESET",
    format: () => translate("messages.blacklist.reset"),
    class: (data: any) => !data.reason.includes("Exceeded") ? "hidden" : "bg-yellow-500 text-white cursor-pointer hover:bg-yellow-600",
    function: (data: any) => {
      actionBlacklistUser(data, 'reset');
      fetchPageData();
    },
  },
  {
    label: "",
    field: "",
    isFunction: true,
    permission: "BLACKLIST.DELETE",
    format: () => translate("messages.blacklist.delete"),
    class: () => "bg-red-500 text-white cursor-pointer hover:bg-red-600",
    function: (data: any) => {
      actionBlacklistUser(data, 'delete');
      fetchPageData();
    },
  },
];
const pageConfig = ref({
  page: 1,
  count: 0,
  pageCount: 0,
  rowsPerPage: 10,
  dataLength: 0,
  search: null
});
const filterForm = ref({
  value: null,
  reason: null,
  type: null,
  username: store.state.user.username
});


const advanceFilterModalSubmit = async (data: boolean) => {
  advanceFilterForm.value.createdByCMS = !advanceFilterForm.value.createdByCMS;
  fetchPageData();
}
const actionBlacklistUser = async (data: any, type: string) => {
  selectedRow.value = {data, type}
  confirmBlacklistUser.value = true
};

const onConfirmBlacklistUser = async (reason: string) => {
  try {
    if (!reason) return alert('please input reason');
    await axios.post(
      `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/blacklist/${selectedRow.value.type}`,
      {
        requestId: Date.now().toString(),
        requestTs: Date.now(),
        id: Number(selectedRow.value.data.id),
        reason
      }
    );
    confirmBlacklistUser.value = false
    fetchPageData();
  } catch (e) {
    alert('failed')
  }
}

const fetchPageData = async () => {
  isLoaded.value = false;
  const { page, rowsPerPage } = pageConfig.value;
  const {
    username,
  } = filterForm.value;
  const payload: {username?: string, keyword?: string|null, limit?: number, offset?: number, createdBy?: string} = {
    username,
    limit: pageConfig.value.rowsPerPage,
    offset: (pageConfig.value.page - 1) * pageConfig.value.rowsPerPage,
    keyword: pageConfig.value.search,
  };
  if(advanceFilterForm.value.createdByCMS === true){
    payload['createdBy'] = 'CMS Admin'
  }
  const url = `${process.env.VUE_APP_API_ENDPOINT}/admin/api/v1/blacklist/list`;
  const data = await axios
    .post(url, payload)
    .then(({ data }) => data.result);
  
  pageConfig.value.dataLength = data.length;

  dataRows.value = data;
  pageConfig.value = {
    ...pageConfig.value,
    pageCount: pageConfig.value.dataLength,
  };
  /** update url to persist page config */
  window.history.replaceState(
    {},
    document.title,
    `user-blacklised?${stringify({ page, rowsPerPage })}`
  );
  isLoaded.value = true;
};
const onSearch = (payload: { from: null; to: null }) => {
  fetchPageData();
};

onMounted(() => {
  pageConfig.value.page = Number(route.query.page) || 1;
  pageConfig.value.rowsPerPage = Number(route.query.rowsPerPage) || 10;
  fetchPageData();
});
/** fetch data when current page was changed */
watch(
  () => pageConfig.value.page,
  () => fetchPageData()
);
/** fetch data when rows per page was changed */
watch(
  () => pageConfig.value.rowsPerPage,
  () => {
    pageConfig.value.page = 1;
    fetchPageData();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(Navbar, {
        title: _ctx.$t('messages.blacklist.blacklistedUsers')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(SearchIcon), {
                class: "h-5 w-5",
                "aria-hidden": "true"
              })
            ]),
            _withDirectives(_createElementVNode("input", {
              id: "search",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pageConfig.value.search) = $event)),
              class: "block w-full bg-white py-2 pl-10 focus:bg-white pr-3 border border-transparent rounded-md leading-5 text-gray-900 placeholder-gray-500 focus:ring-offset-blue-600 focus:ring-white focus:border-white sm:text-sm",
              placeholder: "Search...",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (fetchPageData()), ["enter"])),
              type: "search",
              name: "search"
            }, null, 544), [
              [_vModelText, pageConfig.value.search]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("messages.blacklist.createByCMS")), 1),
            _createVNode(_unref(Switch), {
              modelValue: advanceFilterForm.value.createdByCMS,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((advanceFilterForm.value.createdByCMS) = $event)),
              class: _normalizeClass(["relative inline-flex h-6 w-11 items-center rounded-full", advanceFilterForm.value.createdByCMS
                              ? 'bg-green-500'
                              : 'bg-red-500'
                              ]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (advanceFilterModalSubmit()))
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", {
                  class: _normalizeClass([advanceFilterForm.value.createdByCMS
                              ? 'translate-x-6'
                              : 'translate-x-1'
                              , "inline-block h-4 w-4 transform rounded-full bg-white"])
                }, null, 2)
              ]),
              _: 1
            }, 8, ["modelValue", "class"])
          ])
        ]),
        (_unref(store).state.user.permissions.includes('BLACKLIST.CREATE'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (createBlacklistUser.value = true)),
                class: "ml-3 inline-flex items-center px-3 py-1 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-500 hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-white focus:ring-blue-500"
              }, _toDisplayString(_ctx.$t("messages.blacklist.createBlacklistUser")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(DataTable, {
              columns: columns,
              data: dataRows.value,
              isLoaded: isLoaded.value
            }, null, 8, ["data", "isLoaded"]),
            _createVNode(Pagination, {
              config: pageConfig.value,
              "onUpdate:config": _cache[5] || (_cache[5] = ($event: any) => ((pageConfig).value = $event))
            }, null, 8, ["config"])
          ])
        ])
      ])
    ]),
    _createVNode(UserBlacklistCreateDialog, {
      show: createBlacklistUser.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((createBlacklistUser).value = $event)),
      onCreated: _cache[7] || (_cache[7] = ($event: any) => (fetchPageData()))
    }, null, 8, ["show"]),
    _createVNode(UserBlacklistConfirmDialog, {
      show: confirmBlacklistUser.value,
      "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((confirmBlacklistUser).value = $event)),
      selected: selectedRow.value,
      onSubmit: onConfirmBlacklistUser
    }, null, 8, ["show", "selected"])
  ], 64))
}
}

})